<template>
  <div class="staff-list">
    <Row>
      <Col :xs="24"
           :sm="24">
      <Form :model="formItem"
            ref="formItem"
            :inline="true"
            action="javascript:void(0)">
        <FormItem>
          <Select v-model="formItem.status"
                  clearable
                  style="width:80px"
                  placeholder="状态">
            <Option value="1">正常</Option>
            <Option value="0">禁用</Option>
          </Select>
        </FormItem>
        <FormItem>
          <Select v-model="formItem.auth_status"
                  clearable
                  style="width:80px"
                  placeholder="认证状态">
            <Option value="0">未认证</Option>
            <Option value="1">已认证</Option>
          </Select>
        </FormItem>
        <FormItem>
          <Select v-model="formItem.group_id"
                  clearable
                  placeholder="组织机构">
            <Option v-for="item in grouplist"
                    :value="item.id"
                    :key="item.id">{{ item.name }}</Option>
          </Select>
        </FormItem>
        <FormItem>
          <Input v-model="formItem.key"
                 clearable
                 placeholder="输入姓名或员工编号或手机号"></Input>
        </FormItem>
        <FormItem>
          <Button type="primary"
                  @click="renderTable('formItem')">查找</Button>
        </FormItem>
        <FormItem>
          <Button @click="showModel()"
                  type="success"
                  class="f-r">添加员工</Button>
        </FormItem>
        <FormItem>
          <Button @click="showImportModel()"
                  type="success"
                  :loading='exportLoading'
                  class="f-r">批量导入员工</Button>
          <a style="margin-top:4px;"
             href="/template/staff.xlsx"
             class="f-r ml10">下载员工模版</a>
        </FormItem>
      </Form>
      </Col>
    </Row>
    <Table border
           :columns="columns1"
           ref="selection"
           :data="tablelist"
           :loading="dataloading"></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page ref="listPage"
              :total="pages.total"
              :current="pages.page"
              :page-size="pages.size"
              show-elevator
              show-total
              @on-change="changePage()"></Page>
      </div>
    </div>
    <!-- 添加的弹出 -->
    <Modal v-model="showModalStatus"
           title="添加员工"
           @on-ok="createBrand('brandValidate')"
           :loading="loading">
      <Form :model="brand"
            ref="brandValidate"
            :rules="brandValidate"
            action="javascript:void(0)">
        <FormItem label="组织机构"
                  prop="group_id">
          <Select v-model="brand.group_id"
                  clearable
                  placeholder="组织机构">
            <Option v-for="item in grouplist"
                    :value="item.id"
                    :key="item.id">{{ item.name }}</Option>
          </Select>
        </FormItem>
        <FormItem label="员工名称"
                  prop="name">
          <Input v-model="brand.name"
                 placeholder="输入员工名称..."></Input>
        </FormItem>
        <FormItem label="充值金额"
                  prop="money">
          <Input v-model="brand.money"
                 placeholder="输入充值金额..."></Input>
        </FormItem>
        <FormItem label="员工编号"
                  style="width:100px;">
          <Input v-model="brand.staff_num"
                 placeholder="输入员工编号..."></Input>
        </FormItem>
        <FormItem label="电话号码"
                  style="width:100px;">
          <Input v-model="brand.phone"
                 placeholder="输入电话号码..."></Input>
        </FormItem>
        <FormItem label="身份证号">
          <Input v-model="brand.idcard"
                 placeholder="输入身份证号..."></Input>
        </FormItem>
        <FormItem label="地址">
          <Input v-model="brand.address"
                 placeholder="输入地址..."></Input>
        </FormItem>
        <FormItem label="状态"
                  label-position="top">
          <RadioGroup v-model="brand.status">
            <Radio label="1">正常</Radio>
            <Radio label="0">禁用</Radio>
          </RadioGroup>
        </FormItem>
      </Form>
    </Modal>
    <!-- 修改的弹出 -->
    <Modal v-model="showEditInfoStatus"
           title="修改员工"
           @on-ok="updateBrand('brandValidate')"
           :loading="loading">
      <Form :model="brand"
            ref="brandValidate"
            :rules="brandValidate"
            action="javascript:void(0)">
        <FormItem label="组织机构"
                  prop="group_id">
          <Select v-model="brand.group_id"
                  clearable
                  placeholder="组织机构">
            <Option v-for="item in grouplist"
                    :value="item.id"
                    :key="item.id">{{ item.name }}</Option>
          </Select>
        </FormItem>
        <FormItem label="员工名称"
                  prop="name">
          <Input v-model="brand.name"
                 placeholder="输入员工名称..."></Input>
        </FormItem>
        <FormItem label="员工编号"
                  style="width:100px;">
          <Input v-model="brand.staff_num"
                 placeholder="输入员工编号..."></Input>
        </FormItem>
        <FormItem label="电话号码"
                  style="width:100px;">
          <Input v-model="brand.phone"
                 placeholder="输入电话号码..."></Input>
        </FormItem>
        <FormItem label="身份证号">
          <Input v-model="brand.idcard"
                 placeholder="输入身份证号..."></Input>
        </FormItem>
        <FormItem label="地址">
          <Input v-model="brand.address"
                 placeholder="输入地址..."></Input>
        </FormItem>

        <FormItem label="状态"
                  label-position="top">
          <RadioGroup v-model="brand.status">
            <Radio label="1">正常</Radio>
            <Radio label="0">禁用</Radio>
          </RadioGroup>
        </FormItem>
      </Form>
    </Modal>
    <!-- 批量导入的弹出 -->
    <Modal v-model="showImportModalStatus"
           title="导入任务"
           @on-ok="importStaff('leadInValidate')"
           :loading="loading">
      <Form :model="leadIn"
            ref="leadInValidate"
            :rules="leadInValidate"
            action="javascript:void(0)">
        <FormItem label="选择文件"
                  prop="filePath">
          <file-import v-model="leadIn.file_url"
                       :defaultList="fileListThree"
                       ref="import-filesThree"></file-import>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
import FileImport from "../common/fileimport";

export default {
  name: 'staff-list',
  data () {
    const validateGroupId = (rule, value, callback) => {
      if (this.brand.group_id === '' || this.brand.group_id == undefined) {
        callback(new Error('请选择组织机构'));
      } else {
        callback();
      }
    };
    const validateStaffNum = (rule, value, callback) => {
      if (this.brand.staff_num === '') {
        callback(new Error('员工号必须填写'));
      } else {
        callback();
      }
    };
    const validatePhone = (rule, value, callback) => {
      if (this.brand.phone === '') {
        callback(new Error('电话号码必须填写'));
      } else {
        callback();
      }
    };
    const validateIdCard = (rule, value, callback) => {
      if (this.brand.idcard === '') {
        callback(new Error('身份证号必须填写'));
      } else {
        callback();
      }
    };
    return {
      loading: true,
      dataloading: true,
      grouplist: [],
      fileListThree: [],
      exportLoading: false,
      leadIn: {
        file_url: ""
      },
      showImportModalStatus: false,
      leadInValidate: {
        files: [
          {
            required: true,
            type: "string",
            message: "请选择上传文件",
            trigger: "change"
          }
        ]
      },
      pages: {
        page: 1,
        size: 10
      },
      columns1: [
        {
          title: 'Id',
          key: 'id',
          width: 100,
          fixed: 'left'
        },
        {
          title: '姓名',
          key: 'name',
          fixed: 'left'
        },
        {
          title: '手机号',
          key: 'phone',
          fixed: 'left'
        },
        {
          title: '所属组织',
          key: 'groupname',
          fixed: 'left'
        },
        {
          title: '员工编号',
          key: 'staff_num',
          fixed: 'left'
        },
        {
          title: '企业卡',
          key: 'cardnum',
          fixed: 'left'
        },
        {
          title: '卡密码',
          key: 'cardpwd',
          fixed: 'left'
        },
        {
          title: '认证状态',
          key: 'auth_status',
          fixed: 'left'
        },
        {
          title: '操作',
          key: 'action',
          align: 'left',
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'info',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.showEditInfo(params.row.id)
                  }
                }
              }, '修改'),
              h('Button', {
                props: {
                  type: 'error',
                  size: 'small'
                },
                on: {
                  click: () => {
                    this.remove(params.row.id)
                  }
                }
              }, '删除')
            ]);
          }
        }
      ],
      formItem: {},
      tablelist: [],
      brand: {
        name: '',
        status: "1",
        money: 0,
        staff_num: "",
        phone: "",
        idcard: "",
        address: "",
      },
      showModalStatus: false,
      showEditInfoStatus: false,
      brandValidate: {
        group_id: [
          { required: true, validator: validateGroupId, trigger: 'blur' }
        ],
        name: [
          { required: true, message: '员工名称必须填写', trigger: 'blur' }
        ],
        // staff_num: [
        //   { required: true, validator: validateStaffNum, trigger: 'blur' }
        //   // { required: true, message: '员工号必须填写', trigger: 'blur' }
        // ],
        // phone: [
        //   { required: true, validator: validatePhone, trigger: 'blur' }
        //   // { required: true, message: '电话号码必须填写', trigger: 'blur' }
        // ],
        // idcard: [
        //   { required: true, validator: validateIdCard, trigger: 'blur' }
        //   // { required: true, message: '身份证号必须填写', trigger: 'blur' }
        // ]
      },
    }
  },
  // 计算
  computed: {},
  // 监听
  watch: {},
  created: function () {
    // 取数据
    this.getTableList();
    this.getGrouplist();
  },
  components: {
    FileImport
  },
  methods: {
    getGrouplist: function () {
      var self = this;
      this.$api.staffGroup.list({ "page": 1, "size": 10000 }).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          self.grouplist = res.result.list;
          this.$Message.success(res.msg);
        }
      });
      return;
    },
    getTableList: function () {
      var self = this;
      this.$api.staff.list({ "page": this.pages.page, "size": this.pages.size }).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          self.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    },
    // 展开添加
    showModel () {
      this.brand = {
        name: '',
        status: "1",
        money: 0,
        staff_num: "",
        phone: "",
        idcard: "",
        address: "",
      };
      this.$refs['brandValidate'].resetFields();
      this.showModalStatus = !this.showModalStatus;
    },
    // 添加
    createBrand (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.$api.staff.create(this.brand).then(res => {
            if (res.code == 200) {
              this.showModalStatus = !this.showModalStatus;
              this.brand.name = '';
              this.getTableList();
            }
          });
          this.loading = false
          this.$nextTick(() => {
            this.loading = true;
          });
        } else {
          this.$Message.error('请检查输入的信息是否正确！');
          this.loading = false
          this.$nextTick(() => {
            this.loading = true;
          });
        }
      })
    },
    //展开修改
    showEditInfo: function (index) {
      this.brand = {
        name: '',
        status: "1",
        money: 0,
        staff_num: "",
        phone: "",
        idcard: "",
        address: "",
      };
      this.staff_id = index;
      this.$refs['brandValidate'].resetFields();
      this.showEditInfoStatus = !this.showEditInfoStatus;
      // 取信息
      this.$api.staff.detail({ staff_id: index }).then(res => {
        if (res.code == 200) {
          this.brand = res.result;
          this.brand.status = this.brand.status.toString();
          this.$Message.success(res.msg);
        }
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true;
        });
      });
    },
    // 修改名称
    updateBrand: function (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.brand.staff_id = this.staff_id;
          this.$api.staff.edit(this.brand).then(res => {
            if (res.code == 200) {
              this.$Message.success(res.msg);
              this.showEditInfoStatus = !this.showEditInfoStatus;
              this.getTableList();
            }
            this.loading = false;
            this.$nextTick(() => {
              this.loading = true;
            });
            this.showCreateStatus = !this.showCreateStatus;
          });
        } else {
          this.$Message.error('请检查输入的信息是否正确！');
          this.loading = false
          this.$nextTick(() => {
            this.loading = true;
          });
        }
      })
    },
    // 翻页
    changePage () {
      this.pages.page = this.$refs['listPage'].currentPage;
      this.renderTable(1);
    },
    remove: function (index) {
      // 弹出确认框
      this.$Modal.confirm({
        title: '警告',
        content: '<p>此操作不可恢复，三思而后行...</p>',
        onOk: () => {
          this.$api.staff.remove({ staff_id: index }).then(res => {
            if (res.code == 200) {
              this.$Message.success(res.msg);
              // this.tablelist.splice(index, 1);
              this.getTableList();
            }
          });
        }
      });
    },
    // 筛选
    renderTable: function (name) {
      if (name != 1) {
        this.pages.page = 1;
      }
      this.dataloading = true;
      var ps = {
        key: this.formItem.key,
        group_id: this.formItem.group_id,
        status: this.formItem.status,
        staff_auth: this.formItem.auth_status,
        page: this.pages.page,
        size: this.pages.size,
      };
      this.$api.staff.list(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    },
    // 导入
    showImportModel: function () {
      this.showImportModalStatus = !this.showImportModalStatus;
      this.fileListThree = [];
      this.leadIn.file_url = "";
    },
    importStaff (name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          if (
            this.$refs["import-filesThree"].resList != undefined &&
            this.$refs["import-filesThree"].resList.length
          ) {
            this.leadIn.file_url = this.$refs[
              "import-filesThree"
            ].resList[0].url;
          } else {
            this.leadIn.file_url = "";
            this.$Message.error("请选择上传文件");
            this.loading = false;
            this.$nextTick(() => {
              this.loading = true;
            });
            return;
          }
          this.$nextTick(() => {
            this.loading = true;
          });
          this.$api.staff.import(this.leadIn).then(res => {
            if (res.code == 200) {
              this.getTableList();
            }
            this.loading = false;
            this.$nextTick(() => {
              this.loading = true;
            });
            this.showImportModalStatus = !this.showImportModalStatus;
          });
        } else {
          this.$Message.error("请检查输入的信息是否正确！");
          this.loading = false;
          this.$nextTick(() => {
            this.loading = true;
          });
        }
      });
    },
  },
}
</script>
